import PropTypes from "prop-types";
import "./styles.scss";

function ChargerInfo(props) {
  const { label, value } = props;
  return (
    <div className="charger-info-wrapper">
      <label>{label}</label>
      <p>{value}</p>
    </div>
  );
}

ChargerInfo.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};

export default ChargerInfo;
